export const primaryData = {
    my: {
        title: "မူလတန်း",
        subtitle: "သာမဏေကျော်လုပ်လိုသူများနှင့် အစိုးရပထမပြန်လုပ်လိုသူများအတွက် အခြေခံသင်တန်း",
        subjects: [
            {
                title: "သဒ္ဒါဘာသာ",
                subtopics: [
                    "(က) အခြေပြုသဒ္ဒါ (တွဲဖက်) (တစ်အုပ်လုံး)",
                    "(ခ) အခြေပြုသဒ္ဒါသုတ်နက် (သန္ဓိ၊ နာမ်၊ ကာရက၊ အာချာတ်)"
                ]
            },
            {
                title: "သင်္ဂဟဘာသာ",
                subtopics: [
                    "(က) အဘိဓမ္မတ္ထသင်္ဂဟပါဌ်",
                    "(ခ) အခြေပြုသင်္ဂြိုဟ် (စိတ်၊ စေတသိက်၊ ပကိဏ်း၊ ရုပ်၊ သမုစ္စည်း)"
                ]
            },
            {
                title: "ဓမ္မပဒအဋ္ဌကထာဘာသာ",
                subtopics: ["ယမကဝဂ် ၆-ဝတ္ထု"]
            },
            {
                title: "ပါဠိသိက္ခာဘာသာ",
                subtopics: ["ပါဠိသိက္ခာနှင့် သဒ္ဒါအကျဉ်း တစ်အုပ်လုံး"]
            }
        ],
        note: {
            title: "မှတ်ချက်",
            content: "မူလတန်း ၌ တစ်ဘာသာလျှင် ၈-ပုစ္ဆာ မေးရမည်။ အာဂုံအောင်မှတ် ၁၀-မှတ်နှင့်တကွ အောင်မှတ်မှာ ၃၂-မှတ် ဖြစ်သည်။ ၆၅-မှတ်သည် ဂုဏ်ထူးမှတ်၊ ၇၂-မှတ်သည် ဝိသိဋ္ဌဂုဏ်ထူးမှတ် ဖြစ်သည်။"
        },
        description: [
            "သာမဏေကျော်လုပ်လိုသူများနှင့် အစိုးရပထမပြန်လုပ်လိုသူများအတွက် အခြေခံရအောင် မူလတန်း၌ ၄-ဘာသာ ပြဋ္ဌာန်းထား၏။ သာမဏေကျော်ဟူသည် ပိဋကတ်စာပေကို သဒ္ဒါနှင့် အဘိဓမ္မာကို ရောနှော၍ သင်ယူရသော နည်းစနစ်ဖြစ်၍ သဒ္ဒါအခြေခံ အဘိဓမ္မာအခြေခံ ကောင်းရန် လိုအပ်၏၊ ထိုအတွက် အခြေခံသီးခြား အချိန်တစ်နှစ်ယူ၍ တည်ဆောက်ရ၏။",
            "မူလတန်း၌ သာမဏေကျော်ပထမဆင့်၌ ပြဋ္ဌာန်းထားသော သဒ္ဒါ (သန္ဓိ၊ နာမ်၊ အာချာတ်၊ ကာရက) ၄-ပိုင်း ပြဋ္ဌာန်းထား၏။ အဘိဓမ္မာကိုလည်း စိတ်၊ စေတသိက်၊ ပကိဏ်းပိုင်း ဟူ၍ ၃-မျိုး ပြဋ္ဌာန်းထားသည့်အပြင် အစိုးရအခြေပြုမူလတန်းအတွက်လည်း ရည်ရွယ်၍ ရုပ်ပိုင်း၊ သမုစ္စည်းပိုင်း တို့ကိုလည်း ပြဋ္ဌာန်းထား၏။",
            "မူလတန်းကို တက်ရောက်ထားပြီးသူ ဖြစ်ပါက ပါဠိဘာသာဖြင့် ရေးထားသော စာပေများကို အတော်အတန် ဖတ်ရှုနိုင်နေပြီ ဖြစ်၏။ ကိုယ်တိုင်လည်း ပါဠိစာစီစာကုံးများကို ရေးသားနိုင်နေပြီ ဖြစ်၏။ ထိုသို့ ပညာရေး၌ သိသိသာသာ တိုးတက်လာသည့်အတွက် သာသနာတော်၌ ပျော်မွေ့ လာကြ၏။"
        ]
    },
    en: {
        title: "Primary Grade",
        subtitle: "Foundation Course for Samanera Kyaw and Government First Level Candidates",
        subjects: [
            {
                title: "Grammar (Sadda)",
                subtopics: [
                    "(a) Basic Grammar (Supplementary) (Complete)",
                    "(b) Basic Grammar Advanced (Sandhi, Nama, Karaka, Akhyata)"
                ]
            },
            {
                title: "Sangaha",
                subtopics: [
                    "(a) Abhidhammatthasangaha Pali",
                    "(b) Basic Sangaha (Citta, Cetasika, Pakinnaka, Rupa, Samuccaya)"
                ]
            },
            {
                title: "Dhammapada Commentary",
                subtopics: ["Yamaka Vagga 6 Stories"]
            },
            {
                title: "Pali Sikkha",
                subtopics: ["Complete Pali Sikkha and Grammar Summary"]
            }
        ],
        note: {
            title: "Note",
            content: "In Primary Grade, each subject has 8 questions. With 10 marks for memorization, the passing mark is 32. 65 marks is distinction, and 72 marks is special distinction."
        },
        description: [
            "Four subjects are prescribed in the Primary Grade as a foundation for those who wish to pursue Samanera Kyaw or Government First Level examinations. Samanera Kyaw is a system of learning Pitaka literature integrated with grammar and Abhidhamma, requiring strong foundations in both. This foundation requires a dedicated year of study.",
            "The Primary Grade includes four sections of grammar (Sandhi, Nama, Akhyata, Karaka) as prescribed in Samanera Kyaw First Level. It also covers three types of Abhidhamma (Citta, Cetasika, Pakinnaka), plus Rupa and Samuccaya sections for government basic level purposes.",
            "Upon completing the Primary Grade, students can reasonably read texts written in Pali and compose their own Pali essays. This notable progress in education leads to greater enjoyment in religious studies."
        ]
    }
};